/**
 * AdvancedModelMenu.jsx — Advanced Modeling top-level menu (hidden in Simple Mode).
 *
 * Toggles the technical panels: Variable Sliders, Arc Graphing
 * Visualizer, Character Identity/Archetype, and Writer's Notebook.
 * Also has "Turn On / Turn Off all advanced panels" shortcuts.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuCheckboxItem,
} from '@/components/ui/dropdown-menu';
import { toast } from 'sonner';
import { Menu, MenuItem } from './shared';

export function AdvancedModelMenu({ visible, togglePanel }) {
  const { t } = useTranslation();
  return (
    <Menu label={t('menu.advancedModel')}>
      <DropdownMenuLabel className="text-[11px] uppercase tracking-wider text-muted-foreground">
        {t('menu.technicalPanelsLabel')}
      </DropdownMenuLabel>
      <DropdownMenuCheckboxItem
        checked={!!visible.variables}
        onCheckedChange={() => togglePanel('variables')}
        className="text-[12.5px]"
        data-testid="menu-advmodel-variables"
      >
        {t('menu.variableSliders')}
      </DropdownMenuCheckboxItem>
      <DropdownMenuCheckboxItem
        checked={!!visible.arc}
        onCheckedChange={() => togglePanel('arc')}
        className="text-[12.5px]"
        data-testid="menu-advmodel-arc"
      >
        {t('menu.arcGraphingVisualizer')}
      </DropdownMenuCheckboxItem>
      <DropdownMenuCheckboxItem
        checked={!!visible.advChar}
        onCheckedChange={() => togglePanel('advChar')}
        className="text-[12.5px]"
        data-testid="menu-advmodel-character-identity"
      >
        {t('menu.characterIdentityArchetype')}
      </DropdownMenuCheckboxItem>
      <DropdownMenuCheckboxItem
        checked={!!visible.notebook}
        onCheckedChange={() => togglePanel('notebook')}
        className="text-[12.5px]"
        data-testid="menu-advmodel-notebook"
      >
        {t('menu.writersNotebook')}
      </DropdownMenuCheckboxItem>
      <DropdownMenuSeparator />
      <MenuItem
        data-testid="menu-advmodel-enable-all"
        onClick={() => {
          if (!visible.variables) togglePanel('variables');
          if (!visible.arc)       togglePanel('arc');
          if (!visible.advChar)   togglePanel('advChar');
          toast.success(t('menu.advancedModelingOn'));
        }}
      >
        {t('menu.turnOnAdvancedModeling')}
      </MenuItem>
      <MenuItem
        data-testid="menu-advmodel-disable-all"
        onClick={() => {
          if (visible.variables) togglePanel('variables');
          if (visible.arc)       togglePanel('arc');
          if (visible.advChar)   togglePanel('advChar');
          toast.info(t('menu.advancedModelingOff'));
        }}
      >
        {t('menu.turnOffAdvancedModeling')}
      </MenuItem>
    </Menu>
  );
}
